import type { Product } from "types";

export function extractProductNameHtml(
  product: Pick<Product, "name" | "titleColor">,
): string {
  const raw = product.name || "-";
  if (!product.titleColor) return raw;
  return raw.replace(
    /<(b|strong)(\s|>)/gi,
    `<$1 style="color: ${product.titleColor}"$2`,
  );
}

type ProductNameLabelProps = {
  product: Pick<Product, "name" | "titleColor" | "tagColor">;
  className?: string;
  showColor?: boolean;
};

export function ProductNameLabel({
  product,
  className = "",
  showColor = true,
}: ProductNameLabelProps) {
  const color = product.tagColor || product.titleColor;
  const html = extractProductNameHtml(product);
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {color && !!showColor && (
        <span
          className="inline-block h-4 w-4 flex-shrink-0 rounded-full"
          style={{ backgroundColor: color }}
        />
      )}
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
